import { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation, useParams } from "react-router-dom";
import { getPlainText, updateSeo } from "../utils/seo";

export default function Post(){

  const location = useLocation();
  const { slug } = useParams();
  const initialPost = location?.state?.post?.item;
  const [post, setPost] = useState(initialPost?.slug === slug ? initialPost : null);
  const [isLoading, setIsLoading] = useState(!post);
  const [error, setError] = useState(null);

  useEffect(() => {
    updateSeo({
      title: "Caricamento articolo",
      description: "Caricamento dell'articolo richiesto.",
      canonical: `${window.location.origin}/post/${slug}`,
    });
  }, [slug]);

  useEffect(() => {
    if (post?.slug === slug) {
      return;
    }

    setIsLoading(true);
    setError(null);

    axios
      .get(
        `https://developer.wordpress.org/news/wp-json/wp/v2/posts?slug=${encodeURIComponent(slug)}&_fields=id,slug,date,title,excerpt,content,link,_embedded&_embed=wp:featuredmedia`
      )
      .then((res) => {
        setPost(res.data?.[0] || null);
      })
      .catch((requestError) => {
        console.log(requestError);
        setError("Non riesco a caricare l'articolo.");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [post, slug]);

  useEffect(() => {
    if (!post) {
      return;
    }

    const featuredImage = post?._embedded?.["wp:featuredmedia"]?.[0]?.source_url;

    updateSeo({
      title: getPlainText(post.title.rendered),
      description: getPlainText(post.excerpt.rendered, 160),
      canonical: `${window.location.origin}/post/${post.slug}`,
      image: featuredImage,
      type: "article",
      publishedTime: post.date,
    });
  }, [post]);

  useEffect(() => {
    if (isLoading || post) {
      return;
    }

    updateSeo({
      title: "Articolo non trovato",
      description: error || "L'articolo richiesto non esiste.",
      canonical: `${window.location.origin}/post/${slug}`,
    });
  }, [error, isLoading, post, slug]);

  if (isLoading) {
    return(
      <div className="single">
        <div className="post-container">
          <div className="post-content">
            <div className="top">
              <Link to="/">Home Page</Link>
            </div>
            <h1 className="title">Caricamento...</h1>
          </div>
        </div>
      </div>
    );
  }

  if (error || !post) {
    return(
      <div className="single">
        <div className="post-container">
          <div className="post-content">
            <div className="top">
              <Link to="/">Home Page</Link>
            </div>
            <h1 className="title">Articolo non trovato</h1>
            <div className="content">
              <p>{error || "L'articolo richiesto non esiste."}</p>
            </div>
            <div className="bottom">
              <Link to="/">Home Page</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const date = new Date(post.date).toLocaleDateString("it-IT", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return(
    <div className="single">
      <div className="post-container">
        <div className="post-content" id={post.slug}>
            <div className="top">
              <Link to="/">Home Page</Link>
            </div>
            <h1
              className="title"
              dangerouslySetInnerHTML={{ __html: post.title.rendered }}
            />
            <div className="date">
              {date}
            </div>
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: post.content.rendered }}
            />
            <div className="bottom">
              <Link to="/">Home Page</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
